"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The number of milliseconds in one minute.
 */
exports.MS_PER_MINUTE = 60000;
/**
 * The number of milliseconds in one hour.
 */
exports.MS_PER_HOUR = 3600000;
/**
 * The number of milliseconds in one standard day.
 */
exports.MS_PER_DAY = 86400000;



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-date-math@1.5.14/~/@progress/kendo-date-math/dist/npm/constants.js
// module id = 160
// module chunks = 0